<template>
    <div class="tab-pane fade show active position-relative" id="shipping" role="tabpanel" aria-labelledby="shipping-tab">
        <transition name="vue-table-loader">
            <div class="vue-details-loader" v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
        </transition>
        <div class="product-form-tab">
            <product-lang-toggle></product-lang-toggle>
            <form action="">
                <div class="form-element-container">
                    <div v-for="group in productShipping.items">
                        <div class="row">
                            <div class="col-md-12 clearfix">
                                <h3>{{group.groupingName}}</h3>
                            </div>
                        </div>
                        <input-loader :fields="group.groupItems"></input-loader>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-crud-controls">
                            <button v-on:click="saveShippingData()" type="button" class="btn btn-primary" v-if="$parent.permissionAllowed('manage_products') && $parent.permissionAllowed('manage_shipping')">Update</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events'
    import axios from 'axios'
    import InputLoader from '../form/form-loader.vue';
    import productLangToggle from './product-language-select.vue';

    import moment from 'moment';


    Vue.use(VueEvents)

    export default {
        name: 'product-shipping',
        props: ['productDetails'],
        components:{
            'input-loader': InputLoader,
            'product-lang-toggle': productLangToggle,
        },
        data() {
            return {
                uiStates: {
                    errorMessage: null,
                    showLoading: true,
                },
                product: this.productDetails,
                productShipping: {
                    items: {
                        groupingName: 'Shipping',
                        groupItems: [
                        ]
                    }
                },
                // productShippingClone:[],
                calendarButtonIcon: 'fa fa-calendar',
                inputClass: 'form-control',
            }
        },
        beforeMount() {
            if(this.$parent.productShipping) {
                this.loading = false;
            }
        },
        mounted() {

        },
        created() {
            if( this.$parent.loadedPanelData.shipping && this.$parent.productShippingLanguage === this.$parent.languages.active) {
                this.productShipping = this.$parent.productShipping;
                this.uiStates.showLoading = false;
            }
            if( ! this.$parent.loadedPanelData.shipping || this.$parent.productShippingLanguage !== this.$parent.languages.active) {
                this.loadProductShipping();
                this.$parent.loadedPanelData.shipping = true;
            }
        },
        watch: {
            '$parent.languages.active': 'checkLangChange',
            productShipping: {
                handler: function (value) {
                    if(value.items != undefined) {
                        if (value.items[0].groupItems[0].value == 'notfree'){
                            value.items[0].groupItems[1].is_enabled = true;
                        }
                        else{
                            value.items[0].groupItems[1].is_enabled = false;
                        }
                    }

                    // this.productShippingClone = JSON.parse(JSON.stringify(this.productShipping));
                },
                deep: true
            },
        },
        methods: {
            checkLangChange () {
                this.uiStates.showLoading = true;
                this.productShipping = [];
                this.loadProductShipping();
            },
            loadProductShipping: function () {
                axios.get(base_url+ '/pimapi/products/'+this.product.info.id+'/product-shipping/' + this.$parent.languages.active, {
                    // 'criteria': criteria,
                })
                .then(function (response) {
                    this.productShipping = response.data.payload.shippingData;
                    this.$parent.productShipping = this.productShipping;
                    this.$parent.productShippingLanguage = this.$parent.languages.active;
                    this.uiStates.showLoading = false;
                    // this.productShippingClone = JSON.parse(JSON.stringify(this.productShipping));
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.showLoading = false;
                    this.$parent.alert.message = error.response.data.message;
                    this.$parent.alert.status = 'alert-danger';
                }.bind(this));
            },
            saveShippingData: function () {
                this.uiStates.showLoading = true;
                this.formatDatesForRequest();
                axios.post(base_url + '/pimapi/products/' + this.product.info.id + '/product-shipping/' + this.$parent.languages.active, {
                    'data': this.productShipping,
                })
                .then(function(response) {
                    this.$parent.alert.status = "alert-success";
                    this.$parent.alert.message = "Product successfully saved";
                    this.uiStates.showLoading = false;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.showLoading = false;
                    this.$parent.alert.status = "alert-danger";
                    this.$parent.alert.message = error.response.data.message;
                }.bind(this));
            },
            formatDatesForRequest() {
                this.productShipping.items.forEach(function (group) {
                    group.groupItems.forEach(function (item) {
                        if (item.type == 'date' && item.value != null) {
                            item.value =  moment(item.value).format('YYYY-MM-DD h:mm:ss')
                        }
                    })
                });
            },
        }
    };
</script>

<style scoped lang="scss">
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
